export interface AppUser {
  id: number;
  username: string;
  is_admin: number;
}

export interface AppState {
  user: AppUser | null;
  lang: string | null;
}

type StateKey = keyof AppState;
type Listener<K extends StateKey> = (value: AppState[K]) => void;

const state: AppState = {
  user: null,
  lang: null,
};

const listeners = new Map<StateKey, Listener<StateKey>[]>();

export function getState(): AppState {
  return { ...state };
}

export function setState(patch: Partial<AppState>): void {
  const changed: Partial<AppState> = {};
  for (const key in patch) {
    const k = key as StateKey;
    if (patch[k] !== state[k]) {
      (changed as Record<string, unknown>)[k] = patch[k];
    }
  }
  if (Object.keys(changed).length === 0) return;

  Object.assign(state, changed);
  for (const [key, fns] of listeners) {
    if (key in changed) {
      fns.forEach(fn => fn(state[key]));
    }
  }
}

export function subscribe<K extends StateKey>(key: K, fn: Listener<K>): () => void {
  if (!listeners.has(key)) listeners.set(key, []);
  const arr = listeners.get(key)!;
  const listener = fn as Listener<StateKey>;
  if (arr.includes(listener)) {
    return () => {
      const idx = arr.indexOf(listener);
      if (idx >= 0) arr.splice(idx, 1);
    };
  }
  arr.push(listener);
  return () => {
    const idx = arr.indexOf(listener);
    if (idx >= 0) arr.splice(idx, 1);
  };
}
